import { configureStore } from "@reduxjs/toolkit";
import auth from "./features/auth/authSlice";
import parfumes from "./features/parfumes/parfumesSlice";
import users from "./features/users/usersSlice";

export const store = configureStore({ reducer: { auth, parfumes, users } });
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;